<script setup lang="ts">
/** POST /organizations/{id}/invitations. OrganizationRole: owner · admin · member. */
import Dialog from '~/components/ui/Dialog.vue'
import Choice from '~/components/ui/Choice.vue'
import Field from '~/components/ui/Field.vue'
import Icon from '~/components/ui/Icon.vue'
import ActionButton from '~/components/ui/ActionButton.vue'

defineEmits<{ close: []; submit: [payload: Record<string, unknown>] }>()
const email = ref('')
const role = ref<'admin' | 'member'>('member')
</script>

<template>
  <Dialog title="Invite member" meta="one invitation per email" :width="480" @close="$emit('close')">
    <template #icon><Icon name="mail" /></template>

    <Field v-model="email" label="Work email" type="email" placeholder="teammate@company.com" hint="The invitation expires in seven days" />

    <div class="flex flex-col gap-1.5">
      <span class="text-xs text-muted-foreground">Role</span>
      <Choice title="Member" facts="Works in projects · cannot change billing or keys" :selected="role === 'member'" @click="role = 'member'" />
      <Choice title="Admin" facts="Everything except transferring ownership" :selected="role === 'admin'" @click="role = 'admin'" />
    </div>

    <template #actions>
      <ActionButton label="Cancel" @click="$emit('close')" />
      <ActionButton label="Send invitation" variant="primary" @click="$emit('submit', { email: email.trim(), role })">
        <template #icon><Icon name="mail" /></template>
      </ActionButton>
    </template>
  </Dialog>
</template>
